import React from 'react';
import Expertise1 from '../../images/aktcorp/mild-steel-i-beam.png';
import Expertise2 from '../../images/aktcorp/equepments.jpg';
import Expertise3 from '../../images/Our-Experties/Expertise-1.jpeg';
import Expertise4 from '../../images/Our-Experties/Expertise-8.jpeg';

function OurExpertisedata() {
  return (
    <div className="w-full bg-[#0C2340] text-white">
      <div className="mx-auto px-4 grid grid-cols-1 lg:grid-cols-12 gap-3">
        {/* First Div: Content + Image */}
        <div className="lg:col-span-4 flex flex-col gap-0 duration-300 ease-in-out">
          <div className="bg-white text-[#0C2340] p-6 rounded-t-lg flex flex-col justify-center">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">BUILDING THE FUTURE WITH HIGH-QUALITY STEEL SOLUTIONS</h2>
            <p className="text-base md:text-lg leading-relaxed text-justify">We deliver premium-grade steel solutions designed to meet the toughest demands of modern industries. From structural and industrial applications to custom fabrication, our steel products provide exceptional durabilty, strength, ind precision engineering. Whether for construction, manufacturing, or heavy machinery. our solutions ensure. maximum. performance. longevity, and safety in every project.</p>
          </div>
          <img src={Expertise1} alt="Industry categories" className="w-full h-full object-cover rounded-b-lg" />
        </div>

        {/* Second Div: Content + Image + Content */}
        <div className="lg:col-span-4 flex flex-col gap-6">
          <div className="bg-white text-[#0C2340] p-6 rounded-lg flex flex-col justify-center duration-300 ease-in-out">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">ADVANCED SOLUTIONS FOR FIBER OPTICS</h2>
            <p className="text-base md:text-lg leading-relaxed text-justify">We deliver advanced materials for the electronics industry, including thermal management, conductive adhesives, and protective coatings. Our solutions ensure reliabiity and performance, keeping you ahead in fast-evolving market.</p>
          </div>

          {/* <img src={Expertise2} alt="Industry categories" className="w-full h-full object-cover rounded-lg hover:scale-105 duration-300 ease-in-out" /> */}

          <div className="w-full h-full overflow-hidden rounded-b-lg">
            <img
              src={Expertise2}
              alt="Industry categories"
              className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
            />
          </div>

          <div className="bg-white text-[#0C2340] p-6 rounded-lg flex flex-col justify-center duration-300 ease-in-out">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">SUPERIOR SEALING & PROTECTION FOR EVERY INDUSTRY</h2>
            <p className="text-base md:text-lg leading-relaxed text-justify">Our premium silicone solutions offer exceptional adhesion, flexibility, and resistance to extreme ‘conditions. Designed for industries ranging from electronics to healthcare, our silicones provide reliable sealing, insulation, and protection where it matters most.</p>

          </div>
        </div>

        {/* Third Div: Image + Content + Image */}
        <div className="lg:col-span-4 flex flex-col gap-6">
          {/* <img src={Expertise3} alt="Industry categories" className="w-full h-full object-cover rounded-lg hover:scale-105 duration-300 ease-in-out" /> */}
          <div className="w-full h-full overflow-hidden rounded-b-lg">
            <img
              src={Expertise3}
              alt="Industry categories"
              className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
            />
          </div>
          <div className="bg-white text-[#0C2340] p-6 rounded-lg flex flex-col justify-center duration-300 ease-in-out">
            <h2 className="text-2xl md:text-3xl font-bold mb-4">ADVANCED LUBRICATION FOR PEAK PERFORMANCE</h2>
            <p className="text-base md:text-lg leading-relaxed text-justify">Our advanced lubricants are engineered to reduce: friction, prevent wear, and extend the life of machinery across industries. Whether in automotive, manufacturing, or heavy equipment, our solutions keep operations running smoothly under extreme conditions.</p>
          </div>
          {/* <img src={Expertise4} alt="Industry categories" className="w-full h-full object-cover rounded-lg hover:scale-105 duration-300 ease-in-out" /> */}
          <div className="w-full h-full overflow-hidden rounded-b-lg">
            <img
              src={Expertise4}
              alt="Industry categories"
              className="w-full h-full object-cover transition-transform duration-300 ease-in-out hover:scale-110"
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default OurExpertisedata;
